/**
 * Import required libraries
 */
import React from "react";
import { connect } from "react-redux";

/**
 * Import required elements
 */
// Material-ui components
import {
  Paper,
  ClickAwayListener,
  MenuList,
  Popover,
  MenuItem,
  ListItemIcon,
  ListItemText,
  useTheme
} from "@material-ui/core";
// Material-ui icons
import LanguageIcon from "@material-ui/icons/Language";
import flags from "./flags";
import styles from "./styles";

/**
 * Item Render JSX
 */
const Item = props => {
  const theme = useTheme();
  return (
    <MenuItem
      dense
      onClick={props.setLanguage(props.lang)}
      style={
        props.current === props.lang
          ? {
              background: theme.palette.action.selected
            }
          : null
      }
    >
      <ListItemIcon>
        <img style={{ width: 16 }} src={props.Icon} alt={props.lang} />
      </ListItemIcon>
      <ListItemText>{props.label}</ListItemText>
    </MenuItem>
  );
};

/**
 * Language Render JSX
 */
const LanguageRender = props => {
  let {
    lang,
    setLanguage,
    handleOpen,
    handleClose,
    menuIsOpen,
    buttonRef
  } = props;

  // CSS classnames
  const classes = styles();

  return (
    <div className={classes.container} ref={buttonRef}>
      <LanguageIcon
        className={classes.languageIcon}
        aria-owns={menuIsOpen && "menu-list-grow"}
        aria-haspopup="true"
        onClick={handleOpen}
      />
      <Popover
        className={classes.popover}
        open={menuIsOpen}
        anchorEl={buttonRef.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        <Paper>
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList>
              {Object.entries(flags).map(([_lang, itemProps]) => (
                <Item
                  key={_lang}
                  {...itemProps}
                  lang={_lang}
                  current={lang}
                  setLanguage={setLanguage}
                />
              ))}
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popover>
    </div>
  );
};

/**
 * Export component
 */
// map redux state to props
export default connect(state => ({
  lang: state.locale.lang
}))(LanguageRender);
